import React from 'react'
import TimesheetApprovalList from '../components/Timesheet/TimesheetApprovalList'
const TimesheetApproval = () => {
  return <TimesheetApprovalList />
}

export {TimesheetApproval}